/* Akira: product photos slide in softly while scrolling (desktop stacked gallery, like NOLA) */
(function () {
  if (!window.matchMedia('(min-width: 750px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = Array.prototype.slice.call(document.querySelectorAll('.product__media-list .product__media-item'), 1);
  if (!items.length) return;
  items.forEach(function (el) { el.classList.add('akira-slide'); });
  var ticking = false;
  function check() {
    ticking = false;
    var limit = window.innerHeight * 0.92;
    items = items.filter(function (el) {
      if (el.getBoundingClientRect().top < limit) { el.classList.add('akira-in'); return false; }
      return true;
    });
    if (!items.length) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  check();
})();
